import styled from "styled-components"

import { colors, oldBreakpoints as breakpoints, spacing } from "@izettle/otto"
import { Text } from "@izettle/react"

export const Container = styled.div`
  border: 1px solid ${colors.border.divider};
  position: relative;
  background-color: ${colors.background.default};
  border-radius: ${spacing.xSmall};
  display: flex;
  overflow: hidden;
  flex-direction: column;
  height: 518px;
  width: 560px;

  @media (max-width: ${breakpoints.medium}) {
    width: 100%;
  }

  @media (max-width: ${breakpoints.medium}) and (max-height: ${breakpoints.xLarge}) {
    height: 100%;
    width: 100%;
    border-radius: 0px;
    border: none;
    box-shadow: none;
  }
`
export const Content = styled.div<{ isSuccess?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
  padding: 0 ${spacing.medium};

  ${Text.LargeBold} {
    padding-top: ${spacing.medium};
    ${({ isSuccess }) =>
      `color: ${isSuccess ? colors.text.success : colors.text.error};`};
  }
`

export const Header = styled.div`
  padding: ${spacing.medium};
  border-bottom: 1px solid ${colors.border.divider};
  text-align: center;

  ${Text.Title2} {
    margin: 0;
  }
`
